<template>
	<div class="content">
		<div class="content-assets">
			<div class="flex-cement">
				<div class="cement1">API订单记录</div>
			</div>
			<div class="border-top"></div>
			<div>
				<el-form :inline="true" :model="formInline" class="demo-form-inline">
					<el-form-item label="统计时间">
						<el-date-picker style="width: 350px;" v-model="startTimeDate" type="datetimerange" start-placeholder="开始"
							end-placeholder="结束" :clearable="true" @calendar-change="handleCalendarChange"
							:disabled-date="disabledDate" value-format="YYYY-MM-DD HH:mm:ss" />
					</el-form-item>
					<el-form-item>
						<div class="flex-list">
							<div v-for="(item,index) in dataList" :class="{'dataClick':item.id == idDataLisrt}"
								@click="timeClick(item)" class="dataListClick">{{item.title}}</div>
						</div>
					</el-form-item>
					<el-form-item label="类型名称">
						<el-select v-model="formInline.categoryName" placeholder="请选择" clearable>
							<el-option v-for="(item,index) in listObj" :label="item.name" :value="item.name" />
						</el-select>
					</el-form-item>
					<el-form-item label="精确搜索">
						<el-input v-model="formInline.cardBody" placeholder="卡号/卡密" clearable />
					</el-form-item>
					<el-form-item label="卡种">
						<el-input v-model="formInline.cardInfoStr" placeholder="卡号/卡密" clearable />
					</el-form-item>
					<el-form-item label="订单状态">
						<el-select v-model="formInline.status" placeholder="请选择" clearable>
							<el-option label="处理中" value="0" />
							<el-option label="交易已完成" value="1" />
							<el-option label="交易失败" value="2" />
						</el-select>
					</el-form-item>
					
					<el-form-item>
						<el-button type="primary" @click="onSubmit">查询</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>
	</div>
	<div class="content">
		<div class="content-assets">
			<!-- <el-button type="primary">重新提交失败卡密</el-button> -->
			<el-button type="success" @click="exportExcel">导出(Excel)</el-button>
			<el-table :data="tableData" style="width: 100%">
				<el-table-column label="提交批次号" min-width="170">
					<template v-slot="{ row }">
						<view>
							{{ row.batchNo?row.batchNo:'--' }}
						</view>
					</template>
				</el-table-column>
				<el-table-column label="订单号" min-width="270">
					<template v-slot="{ row }">
						<view>
							{{ row.no?row.no:'--' }}
						</view>
					</template>
				</el-table-column>
				<el-table-column prop="categoryName" label="类型名称" min-width="150" />
				<el-table-column label="卡种" min-width="190">
					<template v-slot="{ row }">
						<view>
							{{row.cardInfoStr.name}}
						</view>
					</template>
				</el-table-column>
				<el-table-column label="卡号/卡密" min-width="190">
					<template v-slot="{ row }">
						<view v-for="(d, index) in row.cardBody" :key="index">
							{{ d.code }}/{{ d.pwd }}
						</view>
					</template>
				</el-table-column>
				<el-table-column label="订单时间" min-width="190">
					<template v-slot="{ row }">
						<div>{{formatTime(row.createTime)}}</div>
					</template>
				</el-table-column>
				<el-table-column label="处理结果" min-width="150">
					<template v-slot="{ row }">
						<div v-if="row.status==1" style="color: #67C23A;">交易成功</div>
						<div v-if="row.status==0">处理中</div>
						<div v-if="row.status==2" style="color: #ff3332;">交易失败</div>
					</template>
				</el-table-column>
				<el-table-column prop="sourcePrice" label="面值" min-width="150" />
				<el-table-column label="费率" min-width="150">
					<template v-slot="{ row }">
						<div>{{row.userRate}}%</div>
					</template>
				</el-table-column>
				<el-table-column prop="realPay" label="结算金额" min-width="150" />
				<el-table-column prop="date" label="回调状态" min-width="150">
					<template v-slot="{ row }">
						<div v-if="row.callbackStatus==1">未回调</div>
						<div v-if="row.callbackStatus==2" style="color: #67C23A;">回调响应成功</div>
						<div v-if="row.callbackStatus==3" style="color: #ff3332;">回调响应失败</div>
					</template>
				</el-table-column>
				<el-table-column label="操作" align="center" fixed="right" width="230">
					<template v-slot="{ row }">
						<el-button type="primary" @click="details(row)">详情</el-button>
						<!-- <el-button type="primary">重新提交</el-button> -->
						<el-button type="primary" @click="reissueNotice(row)">补发通知</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div class="pagination">
				<el-pagination :current-page.sync="formInline.pageNo" @size-change="sizeChange" @current-change="currentChange"
					background :page-sizes='[10,20,30,40,50]' layout="total, sizes, prev, pager, next, jumper" :total="total" />
			</div>
		</div>
	</div>
	<el-dialog v-model="centerDialogVisible" title="订单详情" width="840" align-center>
		<div class="flex-dialog-visible">
			<div class="orderBorder">
				<div class="title">订单号:</div>
				<div class="text">{{detailsOrder.no}}</div>
			</div>
			<div class="orderBorder">
				<div class="title">商户批号:</div>
				<div class="text">{{detailsOrder.batchNo?detailsOrder.batchNo:'--'}}</div>
			</div>
			<div class="orderBorder">
				<div class="title">卡券编号:</div>
				<div class="text">{{detailsOrder.cardId}}</div>
			</div>
			<div class="orderBorder">
				<div class="title">卡劵类型:</div>
				<div class="text">{{detailsOrder.categoryName}}</div>
			</div>
			<div class="orderBorder">
				<div class="title">卡劵名称:</div>
				<div class="text">{{detailsOrder.cardInfoStr.name}}</div>
			</div>
			<div class="orderBorder">
				<div class="title">面值:</div>
				<div class="text">{{detailsOrder.sourcePrice}}</div>
			</div>
			<div class="orderBorder">
				<div class="title">订单金额:</div>
				<div class="text">{{detailsOrder.realPay}}({{detailsOrder.userRate}}%)</div>
			</div>
			<!-- 		<div class="orderBorder">
				<div class="title">回调地址:</div>
				<div class="text"></div>
			</div> -->
			<!-- 	<div class="orderBorder">
				<div class="title">IP:</div>
				<div class="text"></div>
			</div> -->
			<div class="orderBorder">
				<div class="title">提交时间:</div>
				<div class="text">{{formatTime(detailsOrder.createTime)}}</div>
			</div>
			<div class="orderBorder">
				<div class="title">处理时间:</div>
				<div class="text">{{formatTime(detailsOrder.realPaySettleTime)}}</div>
			</div>
			<div class="orderBorder">
				<div class="title">交易状态:</div>
				<div class="text" v-if="detailsOrder.status==1" style="color: #67C23A;">交易成功</div>
				<div class="text" v-if="detailsOrder.status==0">处理中</div>
				<div class="text" v-if="detailsOrder.status==2" style="color: #ff3332;">交易失败</div>
			</div>
			<div class="orderBorder">
				<div class="title">回调状态:</div>
				<div class="text" v-if="detailsOrder.callbackStatus==1">未回调</div>
				<div class="text" v-if="detailsOrder.callbackStatus==2" style="color: #67C23A;">回调响应成功</div>
				<div class="text" v-if="detailsOrder.callbackStatus==3" style="color: #ff3332;">回调响应失败</div>
			</div>
			<div class="orderBorder">
				<div class="title">卡号/卡密:</div>
				<div class="text" v-for="(d, index) in detailsOrder.cardBody" :key="index">
					{{ d.code }}/{{ d.pwd }}
				</div>
			</div>
			<!-- <div class="orderBorder">
				<div class="title">备注:</div>
				<div class="text"></div>
			</div> -->
		</div>
		<template #footer>
			<div class="dialog-footer">
				<el-button type="primary" @click="save">
					关闭
				</el-button>
			</div>
		</template>
	</el-dialog>
</template>

<script setup>
	import {
		onMounted,
		reactive,
		ref
	} from 'vue';
	import {
		merchantOrderPage,
		merchantCardCategory,
		merchantCallbackOrder,
		orderExportExcel
	} from '@/utils/api.js';
	import dayjs from 'dayjs';
	import {
		ElMessage
	} from 'element-plus';

	let ids = ref(1);
	let formInline = reactive({
		pageSize: 10,
		pageNo: 1,
		cardBody: null,
		status: null,
	})
	let idDataLisrt = ref(0)
	let tableData = ref([]);
	let total = ref(0);
	let dataList = ref([{
			id: 1,
			title: '今天'
		},
		{
			id: 2,
			title: '昨天'
		},
		{
			id: 3,
			title: '近7天'
		},
		{
			id: 4,
			title: '一个月'
		}
	]);
	let startTimeDate = ref();
	let detailsOrder = ref({});
	let listObj = ref([]);

	const onSubmit = () => {
		formInline.pageNo = 1;
		if (startTimeDate.value) {
			formInline.startTime = startTimeDate.value[0];
			formInline.endTime = startTimeDate.value[1];
		} else {
			idDataLisrt.value = 0;
			formInline.startTime = null;
			formInline.endTime = null;
		}
		merchantOrderPage(formInline).then(res => {
			tableData.value = res.data.list
			tableData.value.forEach((item, index) => {
				item.cardBody = JSON.parse(item.cardBody);
				item.cardInfoStr = JSON.parse(item.cardInfoStr);
			})
			console.log(tableData.value)
			total.value = res.data.total;
		})
	}

	function infoCategory() {
		merchantCardCategory().then(res => {
			listObj.value = res.data;
		})
	}

	function exportExcel() {
		if (startTimeDate.value) {
			formInline.startTime = startTimeDate.value[0];
			formInline.endTime = startTimeDate.value[1];
		} else {
			formInline.startTime = null;
			formInline.endTime = null;
		}
		let {
			pageSize,
			pageNo,
			...formInlineStiont
		} = formInline;
		orderExportExcel(formInlineStiont).then(res => {
			const url = window.URL.createObjectURL(new Blob([res]));
			const link = document.createElement('a');
			link.href = url;
			link.setAttribute('download', '京卡收API订单记录.xlsx');
			document.body.appendChild(link);
			link.click();
		})
	}

	function reissueNotice(item) {
		let orderIdList = [];
		orderIdList.push(item.id);
		merchantCallbackOrder({
			orderIdList,
		}).then(res => {
			if (res.data) {
				ElMessage({
					message: '补发通知成功',
					type: 'success',
				})
			}
		})
	}

	function timeClick(item) {
		idDataLisrt.value = item.id;
		if (item.title == '今天') {
			showTodayTime();
		} else if (item.title == '昨天') {
			showYesterdayTime();
		} else if (item.title == "近7天") {
			showLast7DaysTime();
		} else {
			showOneMonthTime();
		}
	}

	function showOneMonthTime() {
		// 开始时间：今天0点
		const startDate = new Date();
		startDate.setHours(23, 59, 59, 999);

		// 结束时间：一个月后23点59分59秒
		const endDate = new Date();
		endDate.setMonth(endDate.getMonth() - 1); // 月份加1
		endDate.setHours(0, 0, 0, 0);

		// 格式化并设置时间范围
		let start = formatDate(endDate);
		let end = formatDate(startDate);

		startTimeDate.value = [];
		startTimeDate.value.push(start);
		startTimeDate.value.push(end);
	}

	function showLast7DaysTime() {
		// 开始时间：今天0点
		const startDate = new Date();
		startDate.setHours(23, 59, 59, 999);

		// 结束时间：7天后0点
		const endDate = new Date();
		endDate.setDate(endDate.getDate() - 7);
		endDate.setHours(0, 0, 0, 0);

		// 格式化并设置时间范围
		let start = formatDate(endDate);
		let end = formatDate(startDate);

		startTimeDate.value = [];
		startTimeDate.value.push(start);
		startTimeDate.value.push(end);
	}

	function showTodayTime() {
		const today = new Date();
		setTimeRange(today);
	}

	function showYesterdayTime() {
		const yesterday = new Date();
		yesterday.setDate(yesterday.getDate() - 1);
		setTimeRange(yesterday);
	}


	// 格式化日期为 YYYY-MM-DD HH:mm:ss 格式
	function formatDate(date) {
		const year = date.getFullYear();
		const month = padZero(date.getMonth() + 1); // 月份从0开始，需+1
		const day = padZero(date.getDate());
		const hours = padZero(date.getHours());
		const minutes = padZero(date.getMinutes());
		const seconds = padZero(date.getSeconds());

		return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
	}

	function setTimeRange(date) {
		const year = date.getFullYear();
		const month = padZero(date.getMonth() + 1); // 月份从0开始，需+1
		const day = padZero(date.getDate());

		// 设置开始和结束时间
		let start = `${year}-${month}-${day} 00:00:00`;
		let end = `${year}-${month}-${day} 23:59:59`;
		startTimeDate.value = [];
		startTimeDate.value.push(start);
		startTimeDate.value.push(end);
	}

	function padZero(num) {
		return num < 10 ? `0${num}` : num;
	}

	function currentChange(item) {
		formInline.pageNo = item;
		onSubmit1();
	}

	const pickedStartDate = ref(null);
	// 处理日历变化事件
	const handleCalendarChange = (value) => {
		console.log('calendar-change', value);

		if (value && Array.isArray(value)) {
			const [startDate, endDate] = value;

			if (startDate && !endDate) {
				// 用户选择了开始日期，但还没选择结束日期，将选择的日期储存，用于禁用日期的判断
				pickedStartDate.value = new Date(startDate);
				console.log('开始日期选择:', pickedStartDate.value);
			} else {
				// 清空选择
				pickedStartDate.value = null;
				console.log('清空选择');
			}
		}
	}

	// Element Plus 的禁用日期函数
	const disabledDate = (time) => {
		// 如果没有选择开始日期，不禁用任何日期
		if (!pickedStartDate.value) {
			return false;
		}

		const startYear = pickedStartDate.value.getFullYear();
		const startMonth = pickedStartDate.value.getMonth();
		const currentYear = time.getFullYear();
		const currentMonth = time.getMonth();

		// 禁用与开始日期不在同一月的日期
		return currentYear !== startYear || currentMonth !== startMonth;
	};

	function sizeChange(item) {
		formInline.pageSize = item;
		onSubmit1();
	}

	const onSubmit1 = () => {
		if (startTimeDate.value) {
			formInline.startTime = startTimeDate.value[0];
			formInline.endTime = startTimeDate.value[1];
		} else {
			formInline.startTime = null;
			formInline.endTime = null;
		}
		merchantOrderPage(formInline).then(res => {
			tableData.value = res.data.list
			tableData.value.forEach((item, index) => {
				item.cardBody = JSON.parse(item.cardBody);
				item.cardInfoStr = JSON.parse(item.cardInfoStr);
			})
			console.log(tableData.value)
			total.value = res.data.total;
		})
	}

	function formatTime(date) {
		return dayjs(date).format('YYYY-MM-DD HH:mm:ss');
	}

	let centerDialogVisible = ref(false);

	function details(row) {
		centerDialogVisible.value = true;
		detailsOrder.value = row;
	}

	function save() {
		centerDialogVisible.value = false;
	}

	onMounted(() => {
		onSubmit1();
		infoCategory();
	})
</script>

<style lang="scss" scoped>
	.content-assets {
		padding: 20px 21px;
	}

	.content {
		width: 85%;
		background-color: #fff;
		margin-left: 20px;
		margin-left: auto;
	}

	.flex-cement {
		position: relative;
		display: flex;
		align-items: center;

		.cement1 {
			font-family: PingFang SC, PingFang SC;
			font-weight: 600;
			font-size: 20px;
			color: #333333;
			font-style: normal;
			text-transform: none;
		}
	}

	.border-top {
		width: 99%;
		height: 0px;
		border-top: 1px solid #eeeeee;
		margin-top: 16px;
		padding-top: 16px;
	}

	.demo-form-inline .el-input {
		--el-input-width: 180px;
	}

	.demo-form-inline .el-select {
		--el-select-width: 180px;
	}

	.pagination {
		display: flex;
		justify-content: right;
		margin-top: 20px;
	}

	.flex-dialog-visible {
		display: flex;
		flex-wrap: wrap;
	}

	.orderBorder {
		width: 49%;
		border: 1px solid #E9E9E9;
		display: flex;
		align-items: center;

		.title {
			border-right: 1px solid #E9E9E9;
			width: 100px;
			padding: 10px 15px;
		}

		.text {
			margin-left: 10px;
		}
	}

	.orderBorder:nth-child(even) {
		border-left: none;
	}

	.flex-list {
		display: flex;
	}

	.dataListClick {
		border: 1px solid #ccc;
		padding: 0px 20px;
		font-size: 14px;
		margin-left: 10px;
	}

	.dataListClick:hover {
		cursor: pointer;
	}

	.dataClick {
		border: 1px solid #1884FC;
		background-color: #1884FC;
		color: #fff;
	}
</style>